import React from 'react';
import { Container, Row, Col } from 'bootstrap-4-react';
import portfolioHero from "../../images/portfolio-hero.jpg";
import sample from "../../images/portfolio/france-media-monde-inside.jpg";
import Slide from 'react-reveal/Slide';
import HeroSection from '../../Components/HeroSection/HeroSection';
import Header from '../../Header/Header';
import "../PortfolioPage.css";
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';

class FMD extends React.Component {
    componentDidMount() {
        ReactGA.pageview('/fmd/');
    }
    render() {
        window.scrollTo(0, 0);
        return (
            <div className="portfolio-page">
                <Header />
                <HeroSection pageTitle="Case Studies" background={portfolioHero} />
                <section className='single-portfolio'>
                    <Container>
                        <Row>
                            <Col col="md-4 12" offset="md-1" className="project-image">
                                <img width="100%" src={sample}/>
                            </Col>
                            <Col col="md-7 12" className="text-left">
                                <h1>France Media Monde</h1>
                                <p className="project-description">
                                    Moobifun has partnered with France Media Monde to offer mobile operators a fully managed subscription news service in Senegal and the Ivory Coast. Providing exclusive breaking news alerts and commentary, this premium service is available on a flexible fee basis which can be paid daily, weekly or monthly.
                                </p>
                                <div className="info-project">
                                    <span className="info">
                                        <i className="fa fa-map-marker"></i>
                                        <span>Senegal, Ivory Coast.</span>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Footer/>
            </div>
        );
    }
}
export default FMD;
